import React from 'react';
import {
  Wrapper,
  Item,
  ItemContent,
  DeliveryHeading,
  DeliveryText,
} from './style';

// eslint-disable-next-line
const Address = ({ children, ...rest }) => (
  <ItemContent>
    <DeliveryText>{rest.name}</DeliveryText>
    <DeliveryText>{rest.street}</DeliveryText>
    <DeliveryText>
      {rest.zip} {rest.city}
    </DeliveryText>
    <DeliveryText>{rest.country}</DeliveryText>
  </ItemContent>
);

const DeliverySummary = ({ profile, invoiceAddress, deliveryAddress }) => {
  return (
    <Wrapper>
      <Item>
        <DeliveryHeading>Rechnungsadresse</DeliveryHeading>
        <Address name={profile.customer_name} {...invoiceAddress} />
      </Item>
      <Item>
        <DeliveryHeading>Lieferadresse</DeliveryHeading>
        <Address name={profile.customer_name} {...deliveryAddress} />
      </Item>
    </Wrapper>
  );
};

export default DeliverySummary;



// WEBPACK FOOTER //
// ../shop_main/components/deliverysummary/index.js